import React, { useState } from "react"
import PropTypes from "prop-types"

import { Loader, Header } from "@components"
import { GlobalStyle } from "@styles"
import styled from "styled-components"
import tw from "twin.macro"

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]')
}

const Container = styled.div`
  ${tw`flex flex-col min-h-screen relative`}
`

const Layout = ({ children, location }) => {
  const isHome = location.pathname === "/"
  const [isLoading, setisLoading] = useState(isHome)
  return (
    <>
      <div id="root">
        <GlobalStyle />
        {isLoading && isHome ? (
          <Loader finishLoading={() => setisLoading(!isHome)} />
        ) : (
          <Container>
            <Header isHome={isHome} />
            <div className="content">{children}</div>
          </Container>
        )}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

export default Layout
